/* import __COLOCATED_TEMPLATE__ from './change-conversation-priority.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import {
  PRIORITY_LEVELS,
  priorityLevelDisplay,
  type PriorityLevelName,
} from 'embercom/lib/inbox/priority-levels';

interface Args {
  action: $TSFixMe;
}

interface Signature {
  Args: Args;
}

// Same i18n key map as the macro composer and visual builder picker. Static
// keys per level (ember skill forbids template-literal key construction).
const LEVEL_LABEL_KEYS: Record<PriorityLevelName, string> = {
  none: 'inbox.command-k.set-priority-level.none',
  low: 'inbox.command-k.set-priority-level.low',
  medium: 'inbox.command-k.set-priority-level.medium',
  high: 'inbox.command-k.set-priority-level.high',
  urgent: 'inbox.command-k.set-priority-level.urgent',
};

// Read-only label for the priority action shown inside the apply-rules step
// of the workflow visual builder. Returns null when the action has no level
// metadata (or the flag is off) so the template falls back to the legacy
// "Mark as priority" string.
export default class ChangeConversationPriorityAction extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get selectedLevel(): number | null {
    if (!this.appService.app.canUseFeature('team-inbox-priority-levels')) {
      return null;
    }
    let data = this.args.action?.actionData ?? {};
    if (typeof data.priority_level === 'number') {
      return data.priority_level;
    }
    if (typeof data.priority === 'number') {
      return data.priority;
    }
    return null;
  }

  get isNoneLevel() {
    return this.selectedLevel === PRIORITY_LEVELS.NONE;
  }

  get priorityLevelName(): string | null {
    let level = this.selectedLevel;
    if (level === null) {
      return null;
    }
    let display = priorityLevelDisplay(level);
    return this.intl.t(LEVEL_LABEL_KEYS[display.name]);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::ApplyRules::Actions::ChangeConversationPriority': typeof ChangeConversationPriorityAction;
  }
}
